import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { ILiveApiListResponse } from '@/types/event/live';

export const live = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ILiveApiListResponse>> => {
    return axios.get('/api/event/live', { ...config, params });
};
